var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoubleRoundLid = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M48 20.11a6.89 6.89 0 0 1 1.91 13.51v19.05a3.864 3.864 0 0 1-1.92 7.22c-2.14 0-3.87-1.73-3.87-3.86 0-1.44.79-2.69 1.95-3.36V33.62c-2.87-.83-4.98-3.48-4.98-6.62 0-3.8 3.09-6.89 6.89-6.89Z"
  })));
};
export default SvgDoubleRoundLid;